import type { FC } from 'react';

interface OverviewGroupDetailsEmptyStateProps {
  message: string;
}

/**
 * Placeholder shown when an overview group list has nothing to display.
 */
export const OverviewGroupDetailsEmptyState: FC<OverviewGroupDetailsEmptyStateProps> = ({ message }) => {
  return (
    <div className="tc pv4" data-test-component="OverviewGroupDetails" data-test-element="empty">
      <p className="f5 gray">{message}</p>
    </div>
  );
};
